import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import sfimsLightLogo from 'assets/img/logo/light/SFIMS_logo.png';
import sfimsDarkLogo from 'assets/img/logo/dark/SFIMS_logo.png';
import sfmsLightLogo from 'assets/img/logo/light/SFMS_logo_top.png';
import sfmsDarkLogo from 'assets/img/logo/dark/SFMS_logo_top.png';
import sfshLightLogo from 'assets/img/logo/light/SFSH_logo_top.png';
import sfshDarkLogo from 'assets/img/logo/dark/SFSH_logo_top.png';
import AppContext from 'context/Context';
import { getLoginInform, getHomeURL } from 'function/login';
import { ROUTER_PATH } from 'types/const';
import { RETURN_YN } from 'types/type';

/**
 * 로고
 */
const Logo = ({ at, width, className, textClass, ...rest }) => {
  /* variable */
  const { haccpYn } = getLoginInform();

  /* context */
  const {
    config: { isDark }
  } = useContext(AppContext);

  /* router */
  const { pathname } = useLocation();

  /* state */
  // 로고
  const [logo, setLogo] = useState(sfmsLightLogo);
  // 구분
  const [type, setType] = useState('sfms');

  /* watch */
  useEffect(() => {
    let type = 'sfms';

    if (pathname === ROUTER_PATH.login) {
      type = 'sfims';
    } else if (haccpYn === RETURN_YN.Y) {
      type = 'sfsh';
    }

    setType(type);
  }, [haccpYn, pathname]);
  useEffect(() => {
    const logo = {
      sfims: {
        light: sfimsLightLogo,
        dark: sfimsDarkLogo
      },
      sfms: {
        light: sfmsLightLogo,
        dark: sfmsDarkLogo
      },
      sfsh: {
        light: sfshLightLogo,
        dark: sfshDarkLogo
      }
    };

    setLogo(logo[type][isDark ? 'dark' : 'light']);
  }, [type]);

  /* view */
  return (
    <Link
      to={pathname === ROUTER_PATH.login ? pathname : getHomeURL()}
      className={classNames(
        'text-decoration-none',
        { 'navbar-brand text-left': at === 'navbar-vertical' },
        { 'navbar-brand text-left': at === 'navbar-top' }
      )}
      {...rest}
    >
      <div
        className={classNames(
          'd-flex',
          {
            'align-items-center py-3': at === 'navbar-vertical',
            'align-items-center': at === 'navbar-top',
            'flex-center flex-column fw-bolder fs-5 mb-3': at === 'auth'
          },
          className
        )}
      >
        <img
          src={logo}
          alt={type.toUpperCase()}
          className="mb-2"
          width={width}
        />
      </div>
    </Link>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  width: PropTypes.number,
  className: PropTypes.string,
  textClass: PropTypes.string
};
Logo.defaultProps = { at: 'auth', width: 58 };

export default Logo;
